import * as Sentry from '@sentry/react'

// Suivi d'erreurs via GlitchTip (compatible Sentry). Actif seulement si un DSN
// est fourni (VITE_GLITCHTIP_DSN) — en dev sans DSN, no-op silencieux.
// On garde le SDK minimal: pas de tracing ni de session replay (quota + poids
// de bundle) — uniquement la capture d'exceptions, ce qui aurait affiché
// l'erreur "permissionless" au lieu d'un écran noir muet.

const DSN = import.meta.env.VITE_GLITCHTIP_DSN as string | undefined

export const isTelemetryEnabled = Boolean(DSN)

export function initTelemetry(): void {
  if (!DSN) return
  Sentry.init({
    dsn: DSN,
    release: typeof __RELEASE__ === 'string' ? __RELEASE__ : undefined,
    environment: import.meta.env.DEV ? 'development' : 'production',
    // GlitchTip ignore le tracing; on le coupe pour ne pas gonfler le bundle.
    tracesSampleRate: 0,
    // Ne pas noyer le quota avec le bruit des extensions de navigateur.
    ignoreErrors: [
      /extension\//i,
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
  })
}
